import { gql } from "@apollo/client";

const queryCustomerLabels = gql`
  query customerLabels {
    customerLabels {
      labels
    }
  }
`;

const queryCustomer = gql`
  query customer($guid: ID) {
    customer(guid: $guid) {
      guid
      id
      parentId
      isActive
      displayName
      displayAddress
      customerName
      businessName
      customerAddress
      workAddress
      workPostalCode
      workCity
      workProvince
      city
      province
      postalCode
      phone
      alternatePhone
      faxNumber
      parentId
      doNotContact
      doNotService
      propertyManager
      label
      comments
      addressDetails
      contactDetails
      email
      userId
      props
      lat
      lng
      deletedAt
      billing {
        id
        guid
        dataKey
        maskedPan
        expMonth
        expYear
        cvd
        notes
        isDefault
        createdAt
      }
      billingHistory {
        id
        guid
        response
        createdAt
      }
      attachments {
        guid
        fileName
        filePath
        fileId
        fileSize
        description
        visibility
        type
      }
      user {
        username
        accessGroup
      }
    }
  }
`;

const queryCustomers = gql`
  query customers($where: CustomersWhere) {
    customers(filter: {
      where: $where
    }) {
      edges {
        node {
          guid
          id
          displayName
          displayAddress
          customerName
          businessName
          customerAddress
          workAddress
          workPostalCode
          workCity
          workProvince
          province
          city
          postalCode
          phone
          alternatePhone
          faxNumber
          parentId
          email
          isActive
          label
          comments
          registration
          addressDetails
          contactDetails
          propertyManager
          doNotContact
          doNotService
          deletedAt
          lat
          lng
          billing {
            guid
            maskedPan
            expMonth
            expYear
            cvd
            notes
            isDefault
          }
          attachments {
            guid
            fileName
            filePath
            fileId
            fileSize
            description
            visibility
            type
          }
        }
      },
      totalCount
    }
  }
`;

export {
  queryCustomer,
  queryCustomers,
  queryCustomerLabels
}
